module.exports = __webpack_public_path__ + "img/kp.bfaad572.svg";